var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"title":"Fechamento de caixa","value":_vm.open,"onClose":_vm.close}},[(_vm.open)?_c('ModalContent',{attrs:{"close":_vm.close,"closeCheckout":_vm.closeCheckout}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }